module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_null.a3b9ae68.png";